export { }

declare global {
  interface Date {
    toString (locales?: string | string[]): string;
  }
}

Date.prototype.toString = function (): string {
  return this.toLocaleDateString('fr-FR');
}
